import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ImgProps } from './image.types';

export const Img: StyledComponent<'img', ImgProps> = styled.img<ImgProps>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  display: ${({ $isLoad }: ImgProps): string => $isLoad ? 'block' : 'none'};
`;

export const BrokenImageBox: StyledComponent<'div'> = styled.div`
  width: 100%;
  min-height: 150px;
  height: 100%;
  background-color: ${Color.Gray100};
  display: flex;
  align-items: center;
  justify-content: center;
`;
